import React from 'react';
import { useTranslation } from 'react-i18next';
import ServicePageLayout from '../../component/common/servicesPagesLayout';

const WebPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '⚛️',
      title: t('web.features.1.title'),
      description: t('web.features.1.desc'),
    },
    {
      icon: '🖥️',
      title: t('web.features.2.title'),
      description: t('web.features.2.desc'),
    },
    {
      icon: '🌐',
      title: t('web.features.3.title'),
      description: t('web.features.3.desc'),
    },
    {
      icon: '🔍',
      title: t('web.features.4.title'),
      description: t('web.features.4.desc'),
    },
    {
      icon: '🤖',
      title: t('web.features.5.title'),
      description: t('web.features.5.desc'),
    },
    {
      icon: '🛒',
      title: t('web.features.6.title'),
      description: t('web.features.6.desc'),
    },
  ];

  const process = [
    { title: t('web.process.1.title'), description: t('web.process.1.desc') },
    { title: t('web.process.2.title'), description: t('web.process.2.desc') },
    { title: t('web.process.3.title'), description: t('web.process.3.desc') },
    { title: t('web.process.4.title'), description: t('web.process.4.desc') },
  ];

  const whyChooseUs = [
    { stat: '50+', label: t('web.why.1.label') },
    { stat: '99%', label: t('web.why.2.label') },
    { stat: '24/7', label: t('web.why.3.label') },
    { stat: '5+', label: t('web.why.4.label') },
  ];

  const techStack = [
    { icon: '⚛️', name: 'React' },
    { icon: '🔺', name: 'Next.js' },
    { icon: '🟢', name: 'Node.js' },
    { icon: '🐍', name: 'Python' },
    { icon: '🍃', name: 'MongoDB' },
    { icon: '🐘', name: 'PostgreSQL' },
    { icon: '📘', name: 'TypeScript' },
    { icon: '☁️', name: 'AWS' },
    { icon: '🔥', name: 'Firebase' },
    { icon: '🛍️', name: 'Shopify' },
    { icon: '🐙', name: 'GitHub' },
    { icon: '🔴', name: 'Redis' },
  ];

  const faqs = [
    {
      question: t('web.faq.q1'),
      answer: t('web.faq.a1'),
    },
    {
      question: t('web.faq.q2'),
      answer: t('web.faq.a2'),
    },
    {
      question: t('web.faq.q3'),
      answer: t('web.faq.a3'),
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Web Development Services',
    provider: {
      '@type': 'Organization',
      name: 'BringIt Go',
      url: 'https://www.bringitgo.tech',
    },
    description: 'Professional web development services including frontend, backend, full-stack applications, web scraping, and e-commerce solutions.',
    url: 'https://www.bringitgo.tech/web',
    areaServed: 'Worldwide',
    serviceType: 'Web Development',
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <ServicePageLayout
      accentClass="service-accent-web"
      badge={t('web.badge')}
      title={t('web.heroTitle')}
      description={t('web.heroDescription')}
      features={features}
      process={process}
      whyChooseUs={whyChooseUs}
      techStack={techStack}
      faqs={faqs}
      seo={{
        title: t('web.seo.title'),
        description: t('web.seo.description'),
        canonical: 'https://www.bringitgo.tech/web',
      }}
      structuredData={[structuredData, faqStructuredData]}
    />
  );
};

export default WebPage;
